import { Dialog } from './dialog';
import { l } from '@js/utils/toolbox';

/**
 * Dialog class for displaying a tooltip-style dialog.
 *
 * @class TooltipDialog
 * @param {string} title - The title of the dialog.
 * @param {string} text - The text content of the dialog.
 * @param {Object} options - Optional configuration options for the dialog.
 * @param {string} cacheName - Name to look into storage to see if the tooltip has been used.
 * @param {string} readMore - Optional read more link.
 */
export class TooltipDialog extends Dialog {
	constructor (title, text, options = {}, cacheName, readMore = '') {
		const originalOnAccept = options.onAccept;

		const enhancedOptions = {
			...options,
			onAccept: () => {
				if (cacheName) {
					this.saveCachedTooltip();
				}

				if (typeof originalOnAccept === 'function') {
					originalOnAccept();
				}
			}
		};

		if (readMore) {
			const readMoreContainer = document.createElement('div');
			readMoreContainer.classList.add('readMore--container');

			const anchorLink = document.createElement('a');
			anchorLink.href = readMore;
			anchorLink.title = l('dialog.tooltip.readMore');
			anchorLink.innerText = l('dialog.tooltip.readMore');
			anchorLink.classList.add('readMore--link');
			anchorLink.target = '_blank';
			anchorLink.rel = 'noopener noreferrer';

			readMoreContainer.append(anchorLink);

			enhancedOptions.additionalElements = [
				...(enhancedOptions.additionalElements || []),
				readMoreContainer
			];
		}

		super(title, text, enhancedOptions);
		this.cacheName = cacheName;
	}

	saveCachedTooltip () {
		if (this.cacheName) {
			// TODO: For dismissing messages in the future and not show them again
		}
	}
}
